// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuList_container__1-uV3","containerIsOpen":"MenuList_containerIsOpen__dZ0l4","item":"MenuList_item__3mzIq"};